import MuiSelect, {
  SelectProps,
  SelectChangeEvent,
} from "@mui/material/Select";

const Select: React.FC<SelectProps> = MuiSelect;

export default Select;
export type { SelectProps, SelectChangeEvent };
